"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Creates a deep copy of given object
 * @param json
 */
function deepCopy(json) {
    return JSON.parse(JSON.stringify(json));
}
exports.deepCopy = deepCopy;
//# sourceMappingURL=DeepCopy.js.map